import React from 'react';
import { BUCKET_URL } from '../utils/env-utils';

interface SafeFlightLogoProps {
  mainFlightNumber: string;
  logoSize?: {
    width: number;
    height: number;
  };
}

const SafeFlightLogo: React.FC<SafeFlightLogoProps> = ({ mainFlightNumber, logoSize }) => {
  const handleError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = event.currentTarget;
    const currentRetry = parseInt(target.dataset.retryCount || '0');
    const MAX_RETRIES = 3;

    if (currentRetry < MAX_RETRIES) {
      const newRetry = currentRetry + 1;
      target.dataset.retryCount = newRetry.toString();
      
      // Hide the broken image immediately
      target.style.visibility = 'hidden';

      // Exponential backoff: 1s, 2s, 4s
      const delay = 1000 * newRetry;

      setTimeout(() => {
        const originalSrc = target.src.split('?')[0];
        target.src = `${originalSrc}?retry=${newRetry}&t=${Date.now()}`;
        // Show the image again when attempting retry
        target.style.visibility = 'visible';
      }, delay);
    } else {
      // Final failure - keep hidden
      target.style.visibility = 'hidden';
    }
  };

  const handleLoad = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    // Ensure image is visible when it loads successfully
    event.currentTarget.style.visibility = 'visible';
  };

  return (
    <img
      key={mainFlightNumber}
      width={logoSize?.width}
      height={logoSize?.height}
      style={{
        width: logoSize?.width,
        height: logoSize?.height,
        objectFit: 'contain',
        display: 'block',
      }}
      src={`${BUCKET_URL}/0180x0045/${mainFlightNumber.split(" ")[0]}.bmp`}
      onError={handleError}
      onLoad={handleLoad}
      data-retry-count="0"
      data-flight={mainFlightNumber}
    />
  );
};

export default SafeFlightLogo;